import { useCallback, useEffect, useState } from 'react';

import { JOURNEYS } from '@app-types/product';
import { TagEventType } from '@app-types/tracking';

import useTracking from '@hooks/use-tracking';

import { VariationEnum } from '@helpers/abtest-utils';

import { tagHome, tagHomeFai, tagPacks } from '@constants/tags';

function getPageTagParam(journey: JOURNEYS) {
    switch (journey) {
        case JOURNEYS.FAI:
            return tagHomeFai;
        case JOURNEYS.PACKS:
            return tagPacks;
        default:
            return tagHome;
    }
}

/**
 * Sends the page hit on arrival and exposes `sendPageTag` for client-side journey switches.
 */
export function usePageTracking(journey: JOURNEYS, abTestPhoneVariant: VariationEnum) {
    const { sendTag } = useTracking();
    const [isMounted, setIsMounted] = useState(false);

    const sendPageTag = useCallback(
        (targetJourney: JOURNEYS) => {
            const param = getPageTagParam(targetJourney);
            const paramWithAbTest = {
                ...param,
                pageVariante: {
                    ...param.pageVariante,
                    abtestTelephones:
                        abTestPhoneVariant === VariationEnum.VARIATION_A ? 'Avec_Telephones' : 'Sans_Telephones',
                },
            };
            sendTag(paramWithAbTest, TagEventType.DATA);
        },
        [sendTag, abTestPhoneVariant],
    );

    // Sent on the render after mount: parent effects (useAbTest, setOtisConfigurator) run after child ones.
    useEffect(() => setIsMounted(true), []);
    useEffect(() => {
        if (isMounted) sendPageTag(journey);
    }, [isMounted]);

    return { sendPageTag };
}
